import { DefaultTheme } from 'styled-components';
import { globalStyles } from '../constants';

const bodhiTheme: DefaultTheme = globalStyles;

type TbodhiTheme = typeof bodhiTheme;

export { bodhiTheme, TbodhiTheme };
